<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->
<ng-template #mentorNotesAccordion let-notes="notes">
  <ng-container *ngIf="notes.length > 0">
    <div class="mentor-notes-accordion" [class.open]="showMentorNotes">
      <div class="accordion-header" (click)="showMentorNotes = !showMentorNotes" (keydown.enter)="showMentorNotes = !showMentorNotes">
        <mat-icon class="icon" [class.rotated]="showMentorNotes"> chevron_left </mat-icon>
        <span>
          {{ 'translations.mentors.label.mentorNote' | transloco: { count: notes.length } }}
        </span>
      </div>

      <div class="accordion-body" [class.open]="showMentorNotes">
        <div *ngFor="let note of notes">
          <ptl-review-comment-preview [mentorNote]="note"></ptl-review-comment-preview>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

@switch (formContent?.content.type) {
  @case ('TEXTBOX') {
    <ptl-form-preview-textbox
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [isProjectResource]="isProjectResource"
      [canEditCollectorTemplateForm]="canEditCollectorTemplateForm"
      [isCollectorTemplateForm]="isCollectorTemplateForm"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [languageCode]="languageCode"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-textbox>
  }

  @case ('QUESTION_FORM') {
    <ptl-form-question-preview
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [isProjectResource]="isProjectResource"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [languageCode]="languageCode"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-question-preview>
  }

  @case ('CONNECTED_TEXTBOX') {
    <ptl-form-preview-connected-textbox
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [playlistUid]="playlistUid"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-connected-textbox>
  }

  @case ('PRIVATE_NOTE') {
    <ptl-form-preview-private-note
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [languageCode]="languageCode"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-private-note>
  }

  @case ('CHECKBOX') {
    <ptl-form-preview-checkbox
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [isProjectResource]="isProjectResource"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
      [languageCode]="languageCode"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-checkbox>
  }

  @case ('USER_FILE_UPLOAD') {
    <ptl-form-preview-file-upload
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [isProjectResource]="isProjectResource"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
      [languageCode]="languageCode"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-file-upload>
  }

  @case ('COLLECTOR') {
    <ptl-collector-preview
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [isProjectResource]="isProjectResource"
      [playlistUri]="playlistUri"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
      [languageCode]="languageCode"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-collector-preview>
  }

  @case ('QUIZ') {
    <ptl-form-preview-quiz
      class="form-preview-type"
      [content]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [resourceUri]="resourceUri"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
      [languageCode]="languageCode"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-quiz>
  }

  @case ('BOOKING') {
    <ptl-form-preview-booking
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
      [languageCode]="languageCode"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-booking>
  }

  @case ('PORTFOLIO') {
    <ptl-form-preview-portfolio
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [isProjectResource]="isProjectResource"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
      [languageCode]="languageCode"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-portfolio>
  }

  @case ('PROJECT') {
    <ptl-form-preview-project
      class="form-preview-type"
      [formData]="formContent"
      [learnerFormAnswer]="learnerFormAnswer"
      [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
      [isProjectResource]="isProjectResource"
      [playlistUri]="playlistUri"
      [playlistUid]="playlistUid"
      [resourceUri]="resourceUri"
      [resourceUid]="resourceUid"
      [publisherUri]="publisherUri"
      [packageUri]="packageUri"
      [pageUri]="pageUri"
      [languageCode]="languageCode"
    >
      <div custom-content>
        <ng-container *ngTemplateOutlet="mentorNotesAccordion; context: { notes: formMentorsNotes }"></ng-container>
      </div>
    </ptl-form-preview-project>
  }
}
